"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var classNames = require('classnames');

var TooltipOnEllipsis = require('../tooltipOnEllipsis');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var Button = function Button(_ref) {
  var getClassName = _ref.getClassName,
      automationId = _ref.automationId,
      dataHook = _ref.dataHook,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      ellipsis = _ref.ellipsis,
      children = _ref.children,
      type = _ref.type;
  return /*#__PURE__*/React.createElement("button", {
    className: classNames(getClassName('control-button'), {
      'with-ellipsis': ellipsis
    }),
    "data-aid": automationId,
    "data-hook": dataHook,
    disabled: disabled ? 'disabled' : '',
    onClick: onClick,
    type: type
  }, /*#__PURE__*/React.createElement("div", {
    className: "button-content"
  }, ellipsis ? /*#__PURE__*/React.createElement(TooltipOnEllipsis, null, children) : children));
};

Button.displayName = displayNames.BUTTON;
Button.propTypes = {
  /** content to be displayed */
  children: PropTypes.any,

  /** make the component to be disabled and stop click events */
  disabled: PropTypes.bool,

  /** triggered when button is clicked */
  onClick: PropTypes.func,

  /** wrap content with tooltipOnEllipsis */
  ellipsis: PropTypes.bool,

  /** button type attribute: submit, reset or button */
  type: PropTypes.string
};
module.exports = compose(Button);